import { render } from "./BundleItem.vue?vue&type=template&id=6f764566"
import script from "./BundleItem.vue?vue&type=script&lang=js"
export * from "./BundleItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Glenn\\Source\\GIT\\Giant.B2C\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__